/**
 * Warstwa API: słownik reguł przypisań i konfigurator zgłoszeń — polecenie właściciela 2026-10-02.
 *
 * Trasy backendu:
 *  • `POST categories/reguly-przypisan/podpowiedz`      — frazy do nowej reguły podpowiedziane z tematu zgłoszenia
 *                                                         (`{ temat, configurationId }` → `{ tematOczyszczony, frazy: [{ fraza, zajeta, regulaNazwa, ogolna }] }`);
 *                                                         nic nie zapisuje, bramka jak zapis reguły,
 *  • `GET ticket-modules/{kod}/permissions/szczegoly`   — okno „Uprawnienia modułu”: siedem kluczy z opisem i tym, kto je ma
 *                                                         (nazwiska tylko dla osoby z uprawnieniem „Uprawnienia i dostęp”),
 *  • `GET categories/grupy-glowne`                      — grupy nad kartami i sekcjami (Techniczne, SAP, Cykliczne)
 *                                                         oraz okno SAP, kategoria „Inne zgłoszenie SAP” i `koszSapPowod`
 *                                                         (dlaczego przycisk „SAP” nie działa; null = działa),
 *  • `PUT categories/kosz-sap` `{ categoryId }`         — [domknięcie dz 2026-10-04] „Ustaw jako cel przycisku SAP”
 *                                                         (400 `{ message }` z przyczyną, gdy kategoria się nie nadaje).
 *
 * Temat idzie w CIELE żądania, nie w adresie (dziennik serwera, historia przeglądarki).
 */
export function attach(api) {
    return {
        /** @param {{ temat: string, configurationId?: string|null }} dane */
        podpowiedzFraz: (dane) => api.post("/categories/reguly-przypisan/podpowiedz", dane),
        /** @param {string} kodModulu */
        uprawnieniaModuluSzczegoly: (kodModulu) =>
            api.get(`/ticket-modules/${encodeURIComponent(kodModulu)}/permissions/szczegoly`),
        getGrupyGlowneKategorii: () => api.get("/categories/grupy-glowne"),
        /** @param {string} categoryId */
        ustawKoszSap: (categoryId) => api.put("/categories/kosz-sap", { categoryId }),
    };
}
